export default __webpack_public_path__ + "c8c5029a4217df296202ac09d740f88a.png";